import { Grid, Skeleton } from "@chakra-ui/react";

import type { Workflow } from "@nens/rana/api-v1";
import { RanaHeading } from "@nens/ranalib";

import { SMALL_TILE_CARD_HEIGHT } from "@/components/small-tile-card";
import { useWorkflowListQuery } from "@/queries/query-workflow";

import { WorkflowCard } from "./components/workflow-card";
import { WorkflowLibraryCard } from "./components/workflow-library-card";

interface WorkflowListProps {
  onSelect: (workflow: Workflow) => void;
}

// Three workflows plus the library card
const PREVIEW_WORKFLOW_COUNT = 3;
const SKELETON_COUNT = PREVIEW_WORKFLOW_COUNT + 1;

export function WorkflowList({ onSelect }: WorkflowListProps) {
  const { data, isLoading } = useWorkflowListQuery();
  const workflows = data ?? [];
  const hasWorkflows = workflows.length > 0;

  return (
    <>
      <RanaHeading mb={4} type="h4">
        Workflows
      </RanaHeading>
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(4, 1fr)",
        }}
        gap={4}
        mb={3}
      >
        {isLoading ? (
          Array.from({ length: SKELETON_COUNT }, (_, index) => (
            <Skeleton key={index} h={SMALL_TILE_CARD_HEIGHT} />
          ))
        ) : (
          <>
            {/* Only show the first 3 */}
            {workflows.slice(0, PREVIEW_WORKFLOW_COUNT).map((workflow) => (
              <WorkflowCard
                key={workflow.id}
                workflow={workflow}
                onClick={() => onSelect(workflow)}
              />
            ))}
            {hasWorkflows && <WorkflowLibraryCard workflows={workflows} onSelect={onSelect} />}
          </>
        )}
      </Grid>
    </>
  );
}
